<template>
  <div id="clusters-content">
    <router-link :to="{ name: 'locations' }">
      <img id="country-map-static" src="../assets/mills-static.png" />
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'clusters',
  methods: {
    
  },
  computed: {
    
  },
  created (){

  },
  mounted (){

  },
  data () {
    return {
      
    }
  }
}
</script>

<style lang="scss">

@import '../scss/global';

#clusters-content {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  #country-map-static {
    max-width: 90%;
    max-height: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

}

</style>



// WEBPACK FOOTER //
// Clusters.vue?062ceebc